"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
var js_utils_1 = require("./js-utils");
/**
 * @author arnozhang
 * @date 2019/06/25
 */
var TAG = 'StringUtils';
var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    StringUtils.startsWith = function (value, sub) {
        return value.indexOf(sub) == 0;
    };
    StringUtils.endsWith = function (value, sub) {
        return value.substring(value.length - sub.length, value.length) === sub;
    };
    StringUtils.tryTrim = function (value) {
        if (js_utils_1.JsUtils.isNotEmpty(value)) {
            return value.trim();
        }
        return value;
    };
    StringUtils.isUrl = function (path) {
        return StringUtils.URL_REG.test(path);
    };
    StringUtils.isNumeric = function (value) {
        return value != undefined && StringUtils.NUMBER_REG.test(value);
    };
    StringUtils.capitalize = function (value) {
        return value.charAt(0).toUpperCase() + value.substring(1);
    };
    StringUtils.startWithChar = function (value, ch) {
        return StringUtils.startsWith(value, ch);
    };
    StringUtils.contains = function (value, search) {
        return value.indexOf(search) >= 0;
    };
    StringUtils.equalsIgnoreCase = function (lhs, rhs) {
        if (lhs == rhs) {
            return true;
        }
        return lhs.toUpperCase() === rhs.toUpperCase();
    };
    StringUtils.NUMBER_REG = /^(-|\+)?\d+(\.\d*)?$/;
    StringUtils.URL_REG = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g;
    return StringUtils;
}());
exports.StringUtils = StringUtils;
